<script>
import {defineComponent} from 'vue'
import AspectImg from "@/components/image/AspectImg.vue";
import {mapGetters} from "vuex";

export default defineComponent({
	name: "WishListProduct",
	components: {AspectImg},
	props: {
		product: {
			type: Object
		}
	},
	computed: {
		...mapGetters(['content', 'language']),
		lang() {
			return this.content?.feature?.wishlist || {};
		},
		image() {
			return this.product?.images?.[0];
		},
		imageUrl() {
			return this.image?.url;
		},
		imageAlt() {
			return this.image?.alt;
		},
		percSavings() {
			return Math.round(this.product?.percentageSavings || 0);
		},
		currentPrice() {
			return this.language === 'fr'? String(this.product?.currentPrice)?.replace('.', ',') : this.product?.currentPrice;
		},
		originalPrice() {
			return this.language === 'fr'? String(this.product?.originalPrice)?.replace('.', ',') : this.product?.originalPrice;
		}
	}
})
</script>

<template>
	<div class="wish-list-product">
		<img :alt="imageAlt" :src="imageUrl" class="prod-image"/>
		<div class="details">
			<div class="now red">{{ lang.now }}</div>
			<div class="pricing">
				<div class="current-price red">
					<div class="prefix">$</div>
					<div>{{ currentPrice }}</div>
				</div>
				<div class="original-price"><span>$</span><span>{{ originalPrice }}</span></div>

			</div>
			<div class="perc-save">{{ lang.save }} {{ percSavings }}%</div>
			<div class="prod-name">{{ product.name }}</div>

		</div>


	</div>
</template>

<style lang="scss" scoped>
.wish-list-product {
  background-color: #FFF;
  font-size: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: CT Eastman Condensed;
  font-weight: 700;
  gap: 1em;


  .red {
	color: #D81E05;
  }

  .prod-image {
	aspect-ratio: 1/1;
	width: calc(100% - 20px);
	object-fit: contain;
	margin-top: 10px;
  }

  .details {
	font-family: Lato, Arial, sans-serif;
	line-height: 1.5em;
	width: calc(100% - 20px);

	.now {
	  font-size: 1.16em;
	  font-family: CTEastmanCondensed, sans-serif
	}

	.pricing {
	  font-family: CTEastmanCompressed, sans-serif;
	  font-weight: bold;
	  display: flex;
	  align-items: flex-end;
	  gap: 0.3em;

	  .current-price {
		font-size: 2.66em;
		display: flex;
		align-items: flex-start;
		line-height: normal;

		.prefix {
		  font-size: 0.5em;
		  line-height: normal;
		}

	    [lang="fr"] & {
	      direction: rtl;
	    }

	  }

	  .original-price {
		color: #737373;
		font-size: 1.16em;
		text-decoration: line-through;
		font-weight: 400;
	    display: flex;
		[lang="fr"] & {
		  direction: rtl;
		  gap: 0.1em;
		}
	  }
	}

	.prod-name {
	  font-size: 1em;
	}

	.perc-save {
	  font-size: 1em;
	  color: #737373;
	  font-weight: 400;
	}
  }


}
</style>
